// @ts-nocheck

// TODO: Move this in a place that make sense

import actions from '../actions/network';
import { buildMessageBasketFromData } from '../utils/message';

type doPullBasketProps = {
  requestId?: string | null;
  forceData?: boolean;
};

export const doPullBasket =
  ({ requestId = null, forceData = false }: doPullBasketProps = {}) =>
  (dispatch, getState) => {
    const { basket, loading } = buildMessageBasketFromData(getState());

    const sendParams = {
      basket,
      data: loading || forceData,
    };

    if (requestId) {
      sendParams.requestId = requestId;
    }

    dispatch(actions.send(sendParams));
  };

export default {
  doPullBasket,
};
